import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTreasuryUiContext } from "../providers/TreasuryUiContext";
import CexOrdersFilters from "./CexOrdersFilters";
import {
  selectIsGetMmOrderBookPending,
  selectMmOrderBook,
} from "../treasury.selectors";
import CexOrdersList from "./CexOrdersList";
import { MmOrderType } from "../types/mm-order.type";
import { Divider } from "@mui/material";
import { getMmOrderBookAction } from "../treasury.effects";

interface ICexOrdersProps {
  token: string;
}

export default function CexOrders({ token }: ICexOrdersProps) {
  const { setIsTxWidgetsExpanded } = useTreasuryUiContext();
  const orderBook = useSelector(selectMmOrderBook(token));
  const isGetMmOrderBookPending = useSelector(selectIsGetMmOrderBookPending);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsTxWidgetsExpanded(true);
    dispatch(getMmOrderBookAction(token));

    return () => {
      setIsTxWidgetsExpanded(false);
    };
  }, []);

  return (
    <>
      <CexOrdersFilters token={token} />
      <div className="flex flex-1">
        <CexOrdersList
          type={MmOrderType.Sell}
          orders={orderBook.sell}
          isLoading={isGetMmOrderBookPending}
        />
        <Divider orientation="vertical" />
        <CexOrdersList
          type={MmOrderType.Buy}
          orders={orderBook.buy}
          isLoading={isGetMmOrderBookPending}
        />
      </div>
    </>
  );
}
